import { colors, Modal } from '@insurancemenu/imenu-components-lib';
import styled, { CSSProp } from 'styled-components';
import { Clock } from '@insurancemenu/imenu-components-lib/dist/icons';

export const ModalStyled = styled(Modal)`
  && {
    text-align: center;
    padding: 4rem 2.4rem;
    max-width: 65.6rem;
    min-height: 22rem;
  }
`;

export const IconStyled = styled(Clock)<{ $attemptNumber: number }>`
  margin-bottom: ${({ $attemptNumber }): CSSProp => ($attemptNumber > -1 ? '1.6rem' : '2.6rem')};
  color: ${({ $attemptNumber }): CSSProp => ($attemptNumber > -1 ? colors.orange[600] : colors.green[600])};
`;

export const TitleStyled = styled.p`
  text-align: center;
  font-size: 2.4rem;
  line-height: 3.2rem;
  font-weight: 700;
  letter-spacing: 0.02rem;
  color: ${colors.neutral[900]};
  margin: 0 0 2.6rem;
`;

export const CompleteStatusStyled = styled.b`
  font-size: 1.6rem;
  line-height: 2.8rem;
  color: ${colors.blue[600]};
`;

export const ProgressStyled = styled.div`
  background-color: ${colors.neutral[200]};
  border-radius: 1rem;
  position: relative;
  margin: 1rem auto;
  height: 2rem;
  width: 30rem;
`;

export const ProgressDoneStyled = styled.div<{ $validatedProgressDone: string | number }>`
  background: ${colors.blue[600]};
  border-radius: 1rem;
  height: 100%;
  width: ${({ $validatedProgressDone }): CSSProp => $validatedProgressDone};
  transition: 1s ease 0.3s;
`;
